module.exports = __webpack_public_path__ + "img/news10-2.97b48526.png";